module.exports = __webpack_public_path__ + "static/img/12.1717672.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/zh/12.png
// module id = TylM
// module chunks = 0